import { useCallback, useMemo, useSyncExternalStore } from "react";

// Drop-in, MUI-free replacement for @mui/material's useMediaQuery(query: string).
const canMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

export const useMediaQuery = (query: string): boolean => {
  const mql = useMemo(() => {
    if (!canMatchMedia()) return null;
    return window.matchMedia(query);
  }, [query]);

  const subscribe = useCallback(
    (callback: () => void) => {
      if (!mql) return () => {};
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    [mql]
  );

  const getSnapshot = useCallback(() => (mql ? mql.matches : false), [mql]);
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};

export default useMediaQuery;
